module.exports = __webpack_public_path__ + "img/59.8f62df4.jpg";